/* import __COLOCATED_TEMPLATE__ from './lsg-icon-linkable.hbs'; */
import Component from '@ember/component';

/**
 * This is the play video icon that would show up on most Glimmer media that is able to be linked to
 * looks like a sideways paperclip.
 */
export default Component.extend({
  /**
   * Component props
   */
  tagName: 'span',
  classNames: ['LSG-c-lsg-icon-linkable']
});
